import { connect } from 'react-redux';

import WorkspaceComponent from "../components/WorkspaceComponent";
import {upAddObj,addObj,deleteObject,itemToUpdate,dropBG,manageToast,fileToUpload,suggestionPopup,openLibrarySection, nextBtnClicked, startTour, swapItemUndo, setSelectedItems, startPlay, addTween, showLibrary, setZoom, setZIndex, changeBg, setCopyItemType, copyObjects, cutObjects, pasteItems, setPropertyWindow, setTextOptions, updateTextStatus, deleteBG, toggleBgCrop, deleteItem, setSelectedScene, loadCommonPopup, addScene, showSlides, duplicateScene, removeScene,updatePlayHead, swapItem, removeFromBg, draggedFile,setFullScreen,setPlayAll , setPlayerPosition ,setScenePosition,removeScenePosition  , setAutoPlay,setPreview, setWorkspaceStage, setZoomFit,setSlideJump,addSlideLabelData,setIsShapeInGrp} from '../actions/index';

const mapStateToProps = (state, ownProps) => ({
    project              : state.project,
    maxIndex             : state.project.getIn(['scenes', state.localStore.get("selectedScene"), 'workspaceItems']),
    selectedScene        : state.localStore.get("selectedScene"),
    selectedItems        : state.localStore.get("selectedItems"),
    selectedCamera       : state.localStore.get("selectedCamera"),
    workspaceWidth       : state.project.get("width"),
    workspaceHeight      : state.project.get("height"),
    sceneData            : state.project.getIn(["scenes", state.localStore.get("selectedScene")]),
    scenes               : state.project.getIn(["scenes"]),
    zoomFactor           : state.localStore.get("zoomFactor"),
    prevZoomFactor       :   state.localStore.get("prevZoomFactor"),
    isFullScreen        : state.localStore.get("isFullScreen"),
    textStatus           : state.localStore.get("textStatus"),
    playHeadValue        : state.localStore.get("playHeadValue"),
    swapDetails          : state.localStore.get("swapDetails"),
    isCropping           : state.localStore.get("isCropping"),
    transformStatus      : state.localStore.get('transformStatus'),
    isWorkspaceTextFocus : state.localStore.get('isWorkspaceTextFocus'),
    videos               : state.project.get('videos'),
    isPlay               : state.localStore.getIn(['isPlay']),
    isPlayAll            : state.localStore.getIn(['isPlayAll']),
    showLibrary          : state.localStore.get('showLibrary'),
    workspaceBounds      : state.localStore.get('workspaceBounds'),
    workspaceGrid        : state.localStore.get("workspaceGrid"),
    copiedItem           : state.localStore.get("copiedItem"),
    selectedMedias       : state.localStore.get("selectedMedias"),
    isBgCropping         : state.localStore.get("isBgCropping"),
    selectedScenes       : state.localStore.get("selectedScenes"),
    animakerType         : state.localStore.get("animakerType"),
    propertyWindow       : state.localStore.get("propertyWindow"),
    transitionLibrary    : state.library.get('TRANS'),
    showSlidePanel       : state.localStore.get('showSlidePanel'),
    t1                   : state.localStore.get('t1'),
    isLoaded             : state.localStore.get('isLoaded'),
    timelineHeight       : state.localStore.get("timelineHeight"),
    connections          : state.localStore.get("connections"),
    overallDuration      : state.project.getIn(["duration"]),
    commonPopup          : state.localStore.getIn(['commonPopup']),
    workspaceStage       : state.localStore.get("workspaceStage"),
    screenshots          : state.localStore.get("screenshots"),
    screenShotsHandler   : state.localStore.get("screenShotsHandler"),
    fontScenes           : state.localStore.getIn(["loadedFonts", "scenes"]),
    ownerId              : state.localStore.getIn(["userDetails", "owner"]),
    editclicked          : state.localStore.get('editClicked'),
    undoProp             :   state.localStore.get('undoProp'),
    browserName          : state.localStore.get('browserName'),
    isUserActive         : state.localStore.get('isUserActive'),
    isToolCropping       : state.localStore.get('isToolCropping'),
    updateItems          : state.localStore.get('itemToUpdate'),
    isUploadInProcess    : state.localStore.get('isUploadInProcess'),
    undoResize           : state.localStore.get('undoResize'),
    draggedFileItem      : state.localStore.get('draggedFile'),
    libCurrentFolder     : state.localStore.get('libCurrentFolder'),
    currentSceneNumber   : state.localStore.get('currentSceneNumber'),
    autoPlay             : state.localStore.get('autoPlay'),
    fromStart            : state.localStore.get("fromStart"),
    isPreview            : state.localStore.get('isPreview'),
    libSection           : state.localStore.get('libSection'),
    isFit                : state.localStore.get('isFit'),
    loadedFonts          : state.localStore.get("loadedFonts"),
    isfontLoadedTxtGrp   : state.localStore.get('isfontLoadedTxtGrp')

})


const mapDispatchToProps = (dispatch, ownProps) => ({
    setSelectedItems    : (data, socket) => { dispatch(setSelectedItems(data, socket)) },
    setZoom             : (data) => { dispatch(setZoom(data)) },
    setZIndex           : (data, socket) => { dispatch(setZIndex(data, socket)) },
    changeBg            : (data, socket) => { dispatch(changeBg(data, socket)) },
    addTween            : (data, tweenType) => { dispatch(addTween(data, tweenType)) },
    startPlay           : (data, source, playHead) => { dispatch(startPlay(data, source, playHead)) },
    showLibraryTab      : (data) => { dispatch(showLibrary(data)) },
    setCopyItemType     : (data) => { dispatch(setCopyItemType(data)) },
    copyObjects         : (data) => { dispatch(copyObjects(data)) },
    cutObjects          : (data) => { dispatch(cutObjects(data)) },
    pasteItems          : (data, socket) => { dispatch(pasteItems(data, socket)) },
    setPropertyWindow   : (data) => { dispatch(setPropertyWindow(data)) },
    setTextOptions      : (data) => { dispatch(setTextOptions(data)) },
    updateTextStatus    : (data) => { dispatch(updateTextStatus(data)) },
    deleteBG            : (data, socket) => { dispatch(deleteBG(data, socket)) },
    deleteItem          : (data, socket) => { dispatch(deleteItem(data, socket)) },
    toggleBgCrop        : () => { dispatch(toggleBgCrop()) },
    swapItem            : (data) => { dispatch(swapItem(data)) },
    swapItemUndo        : (data) => {dispatch(swapItemUndo(data))},
    flipBG              : (data, socket) => { dispatch({type : "UPDATE_BG", data : data, socket : socket}) },
    setSelectedScene    : (data, time, selectedScenes, socket) =>
    {
        dispatch(setSelectedScene(data, time, selectedScenes, socket))
    },
    setWorkspaceStage:(data) => {
      dispatch(setWorkspaceStage(data))
  },
  
  setZoomFit:(data) => {
    dispatch(setZoomFit(data))
},
    openCommonPopup: (value) =>
    {
        dispatch(loadCommonPopup(value))
    },
  
    onAddScene: (data, socket) =>
    {
        dispatch(addScene(data, socket))
    },
    
    showSlides: (data) =>
    {
        dispatch(showSlides(data))
    },
    onDuplicateScene: (data, socket) =>
    {
        dispatch(duplicateScene(data, socket))
    },
    onRemoveScene: (data, socket) =>
    {
        dispatch(removeScene(data, socket))
    },
   
    updateFonts: (data) => {
        dispatch({type : "UPDATE_FONTS", data : data})
    },
      addObj: (data,socket) => {
        dispatch(addObj(data,socket))
      },
      dropBG: (data) => {
        dispatch({type : "UPDATE_SLIDE",data : data})
      },
      openLibrarySection : (data) => { dispatch(openLibrarySection(data))},
      startTour : (data) => {dispatch(startTour(data))},
      nextBtnClicked : (data) => {
        dispatch(nextBtnClicked(data))
      },
      suggestionPopup  : (data) => {
        dispatch(suggestionPopup(data))
      },
      updateProject  : (data) => {
        dispatch({type : "UPDATE_PROJECT", data : data})
      },
      fileToUpload : (data) => {
          dispatch(fileToUpload(data))
      },
      manageToast : (data) => {
        dispatch(manageToast(data))
      },
      itemToUpdate : (data) => {
          dispatch(itemToUpdate(data))
      },
      dropVideoBg : (data, deleteData, socket) => {
          dispatch(dropBG(data, deleteData, socket))
      },
      upAddObj : (data, socket) => {
          dispatch(upAddObj(data, socket))
      },
      draggedFile : (data) => {dispatch(draggedFile(data))},
      updateItem : (data, socket) => {
        dispatch({type : "UPDATE_ITEM", data : data, socket : socket})
    },
    deleteObject: (type, socket, id, selectedScene, selectedItem) => {
        dispatch(deleteObject(type, socket, id, selectedScene, selectedItem))
      },
      setFullScreen: (data) => {dispatch(setFullScreen(data))},
      setPlayAll: (data, fromStart) => {
        dispatch(setPlayAll(data, fromStart))
      },
      setPlayerPosition:(data) => { dispatch(setPlayerPosition(data)) },
      setScenePosition : (data  , currentSceneNumber , currentSceneStartTime , currentSceneDuration) =>{
       dispatch(setScenePosition(data  , currentSceneNumber , currentSceneStartTime , currentSceneDuration))},
       removeScenePosition:(data) => { dispatch(removeScenePosition(data))},
       setAutoPlay:(data)=>{dispatch(setAutoPlay(data))},     
       setPreview:(data)=>{dispatch(setPreview(data))},
       fontLoaded : (data) => { dispatch({type : "FONT_LOADED", data : data}) },
       setSlideJump: (data) => {
        dispatch(setSlideJump(data))
      },
      addSlideLabelData: (data) => {
        dispatch(addSlideLabelData(data))
      },
      setIsShapeInGrp: (data) => {
        dispatch(setIsShapeInGrp(data))
      },
      initiateMove : (data) => { dispatch({type : "INITIATE_MOVE", data : data}) },

})

const Workspace = connect(mapStateToProps, mapDispatchToProps)(WorkspaceComponent)

export default Workspace







// WEBPACK FOOTER //
// ./src/containers/Workspace.js